import { useState } from "react";
import DescCard from "./Questions/descCard/DescCard";
import FillBlankCard from "./Questions/FillBlankCard/FillBlankCard";
import McqCard from "./Questions/McqCards/McqCard";
import MmcqCard from "./Questions/MmcqCards/MmcqCard";
import OneWord from "./Questions/OneWord/OneWord";
import TFCard from "./Questions/TFCard/TFCard";
import AssertionReasoning from "./Questions/AssertionReasoning/AssertionReasoning";
import { ReactComponent as Loader } from "./Questions/Loader/Loader.svg";
import { data as dummyData } from "./helper";

const useSlider = (color) => {
  const [index, setIndex] = useState(0);
  const [data] = useState(dummyData);

  const handleSlide = (e, prev = false) => {
    if (!prev) {
      if (data[index + 1]) {
        return setIndex((state) => state + 1);
      }
      return setIndex(0);
    }
    if (data[index - 1]) return setIndex((state) => state - 1);
    return setIndex(data.length - 1);
  };

  const showSlide = (
    question,
    questionCount,
    correctAnswer,
    setCorrectAnswer,
    loading
  ) => {
    const props = question;
    const type = question?.questionType;
    if (!question || !question?.question || loading) return <Loader />;
    if (type === "mcq")
      return (
        <McqCard
          data={props}
          correctAnswer={correctAnswer}
          setCorrectAnswer={setCorrectAnswer}
          number={questionCount}
          color={color}
        />
      );
    if (type === "mmcq")
      return (
        <MmcqCard
          data={props}
          correctAnswer={correctAnswer}
          setCorrectAnswer={setCorrectAnswer}
          number={questionCount}
          color={color}
        />
      );
    if (type === "fillup")
      return (
        <FillBlankCard
          data={props}
          correctAnswer={correctAnswer}
          setCorrectAnswer={setCorrectAnswer}
          number={questionCount}
          color={color}
        />
      );
    if (type === "oneword")
      return (
        <OneWord
          data={props}
          correctAnswer={correctAnswer}
          setCorrectAnswer={setCorrectAnswer}
          number={questionCount}
          color={color}
        />
      );
    if (type === "description")
      return (
        <DescCard
          data={props}
          correctAnswer={correctAnswer}
          setCorrectAnswer={setCorrectAnswer}
          number={questionCount}
          color={color}
        />
      );
    if (type === "correctstatement")
      return (
        <TFCard
          data={props}
          correctAnswer={correctAnswer}
          setCorrectAnswer={setCorrectAnswer}
          number={questionCount}
          color={color}
        />
      );
    if (type === "assertion-reasoning")
      return (
        <AssertionReasoning
          data={props}
          correctAnswer={correctAnswer}
          setCorrectAnswer={setCorrectAnswer}
          number={questionCount}
          color={color}
        />
      );
  };

  return [handleSlide, showSlide];
};

export default useSlider;
